import React from 'react';
import { Outlet } from 'react-router-dom';



const Root = () => {
    //console.log("Root component mounted");

    return (
        <Outlet />  // Just renders child routes
    );
};

export default Root;
